import { DepartmentManager, SubmitDrivingExemptionModel, UserSupervisor, UserDrivingExemptionList, SubmitOnBehalfDrivingExemptionModel } from "../models/api/models";
import appSettings from "../settings/appSettings";
import { httpGet, httpPost } from "./httpService";

const drivingExemptionUriPath = new URL('/api/exemption', appSettings.api.portalApi);
const drivingExemptionFeatureToggleUriPath = new URL('/api/featuretoggle', appSettings.api.portalApi);
const departmentManagersUriPath = `${drivingExemptionUriPath}/departmentmanagers`;
const drivingExemptionSubmit = `${drivingExemptionUriPath}/submit`;
const drivingExemptionReportToManager = `${drivingExemptionUriPath}/reporttomanager`;
const drivingExemptionValidateEmail = `${drivingExemptionUriPath}/validateemail`;
const drivingExemptionUserList = `${drivingExemptionUriPath}/UserExemptionList`;
const drivingExemptionAdminList = `${drivingExemptionUriPath}/AdminExemptionList`;
const gnhFormsFeatureTogglePath = `${drivingExemptionFeatureToggleUriPath}/gnh-forms`;
const drivingExemptionSubmitOnBehalf = `${drivingExemptionUriPath}/onbehalf`;
const drivingExemptionOnbehalfReportToManager = `${drivingExemptionUriPath}/reporttomanager`;

export const getAllDepartmentManagers = async () => {
    return await httpGet<DepartmentManager[]>(departmentManagersUriPath.toString())
        .catch(() => []);
};

export const submitDrivingExemption = async (form: SubmitDrivingExemptionModel) => {
    return await httpPost<number>(`${drivingExemptionSubmit}`, form)
        .catch(e => { console.log(e); return -1 });
};

export const getUserReportToManager = async () => {
    return await httpGet<UserSupervisor>(drivingExemptionReportToManager.toString())
        .catch(e => { console.log(e); return {} as UserSupervisor });
}

export const validateManagerEmail = async (form: string | undefined) => {
    return await httpPost<boolean>(`${drivingExemptionValidateEmail}`, form)
        .catch(e => { console.log(e); return false });
};

export const getUserDrivingExemptionList = async () => {
    return await httpGet<UserDrivingExemptionList[]>(drivingExemptionUserList.toString())
        .catch(e => { console.log(e); return [] as UserDrivingExemptionList[] });
}

export const getAdminDrivingExemptionList = async () => {
    
    return await httpGet<UserDrivingExemptionList[]>(drivingExemptionAdminList.toString())
        .catch(e => { console.log(e); return [] as UserDrivingExemptionList[] });
}

export const gnhFormsFeatureToggle = async () => {
    return await httpGet<boolean>(`${gnhFormsFeatureTogglePath}`)
        .catch(e => { console.log(e); return false });
};

export const submitOnBehalfDrivingExemption = async (form: SubmitOnBehalfDrivingExemptionModel) => {
    return await httpPost<number>(`${drivingExemptionSubmitOnBehalf}`, form)
        .catch(e => { console.log(e); return -1 });
};

export const getUserOnbehalfReportToManager = async (onbehalfUserId?: number) => {
    return await httpGet<UserSupervisor>(`${drivingExemptionReportToManager}/${onbehalfUserId}`)
        .catch(e => { console.log(e); return {} as UserSupervisor });
}